angular.module('eatself')
.filter('trpd', function() {
  return function(str) {
	return str;
  };
})